import { buildCollection } from "@camberi/firecms";
import { RecordCount } from "../components/RecordCount";

export const arambhaForms23Collection = buildCollection({
  path: "arambhaForm2023",
  name: "Arambha Form 2023",
  singularName: "arambhaForm2023",
  group: 'Arambha Yoga Day Forms',
  description: "Submission records for Arambha Yoga Day 2023, including participant info, contact details, and preferences.",
  permissions: () => ({
    edit: false,
    create: false,
    delete: false,
  }),
  extraActions: ({ path }) => <RecordCount path={path} />,
  properties: {
    ticketID: {
      name: "Ticket ID",
      validation: { required: true },
      dataType: "string",
    },
    name: {
      name: "Name",
      validation: { required: true },
      dataType: "string",
    },
    age: {
      name: "Age",
      validation: { required: true },
      dataType: "string",
    },
    email: {
      name: "Email",
      validation: { required: true },
      dataType: "string",
    },
    phone: {
      name: "Phone",
      validation: { required: true },
      dataType: "string",
    },
    location: {
      name: "Location",
      validation: { required: true },
      dataType: "string",
    },
    member: {
      name: "Member",
      validation: { required: true },
      dataType: "string",
    },
    tshirt: {
      name: "T-Shirt Size",
      validation: { required: true },
      dataType: "string",
    },
    gender: {
      name: "Gender",
      validation: { required: true },
      dataType: "string",
    },
    createdAt: {
      name: "Submission Date",
      validation: { required: true },
      dataType: "date",
    },
  },
});
